'use client'

import classNames from 'classnames'
import { isFunction, map, isEqual } from 'lodash-es'
import { useCallback, useMemo } from 'react'
import PropTypes from 'prop-types'

const THEMES = {
  line: {
    wrap: 'flex space-x-32 border-b-2',
    item: 'text-base pb-6 cursor-pointer border-b-2 -mb-2 md:text-xl',
    active: 'text-primary border-b-primary',
    inactive: 'text-font'
  },
  block: {
    wrap: 'flex space-x-2',
    item: 'text-lg cursor-pointer px-20 py-18 border rounded-t-md translate-y-1 text-center',
    active: 'bg-white border-b-white font-bold',
    inactive: 'bg-neutral-1'
  }
}
export default function SectionTabs({
  data,
  value,
  onChange,
  theme = 'line',
  className
}) {

  const styles = useMemo(() => THEMES[theme], [theme])
  const clickHandle = useCallback(item => {
    return () => {
      isFunction(onChange) && onChange(item)
    }
  }, [onChange])

  return (
    <div className={classNames(styles.wrap, className)}>
      {
        map(data, (item, idx) => (
          <span
            key={idx}
            className={classNames(styles.item, isEqual(item, value) ? styles.active : styles.inactive)}
            onClick={clickHandle(item)}
          >{item.label}</span>
        ))
      }
    </div>
  )
}

SectionTabs.propTypes = {
  theme: PropTypes.oneOf(['line', 'block'])
}